import { selectKeyAuthorizeList,insertKeyAuthorize,ICAuthorize,clearICAuthorize,deleteICAuthorize,selectTerminalAuthorize,refreshIC } from "../../api/config/modules/ICEmpower";

const state = {
    selectKeyAuthorizeList: {},
    insertKeyAuthorize: {},
    ICAuthorize: {},
    clearICAuthorize: {},
    deleteICAuthorize: {},
    selectTerminalAuthorize: {},
    refreshIC: {}
};

const mutations = {
  SET_SELECTKEYAUTHORIZELIST: (state, selectKeyAuthorizeList) => {
    state.selectKeyAuthorizeList = selectKeyAuthorizeList;
  },
  SET_INSERTKEYAUTHORIZE: (state, insertKeyAuthorize) => {
    state.insertKeyAuthorize = insertKeyAuthorize;
  },
  SET_ICAUTHORIZE: (state, ICAuthorize) => {
    state.ICAuthorize = ICAuthorize;
  },
  SET_CLEARICAUTHORIZE: (state, clearICAuthorize) => {
    state.clearICAuthorize = clearICAuthorize;
  },
  SET_DELETEICAUTHORIZE: (state, deleteICAuthorize) => {
    state.deleteICAuthorize = deleteICAuthorize;
  },
  SET_SELECTTERMINALAUTHORIZE: (state, selectTerminalAuthorize) => {
    state.selectTerminalAuthorize = selectTerminalAuthorize;
  },
  SET_REFRESHIC: (state, refreshIC) => {
    state.refreshIC = refreshIC;
  },
};

const actions = {
  GET_SELECTKEYAUTHORIZELIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectKeyAuthorizeList(data)
        .then((res) => {
          commit("SET_SELECTKEYAUTHORIZELIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTKEYAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertKeyAuthorize(data)
        .then((res) => {
          commit("SET_INSERTKEYAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ICAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        ICAuthorize(data)
        .then((res) => {
          commit("SET_ICAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CLEARICAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        clearICAuthorize(data)
        .then((res) => {
          commit("SET_CLEARICAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEICAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteICAuthorize(data)
        .then((res) => {
          commit("SET_DELETEICAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTTERMINALAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectTerminalAuthorize(data)
        .then((res) => {
          commit("SET_SELECTTERMINALAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_REFRESHIC: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        refreshIC(data)
        .then((res) => {
          commit("SET_REFRESHIC", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
